import { initializeApp } from "firebase/app";
import { getAuth, signOut } from "firebase/auth";
import { Link, useNavigate } from "react-router-dom";
import { firebaseConfig } from "../utils/firebaseConfig";
import Logo from "./../images/logo.png";

const Header = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  initializeApp(firebaseConfig);
  const navigate = useNavigate();

  const handleLogout = () => {
    const auth = getAuth();
    signOut(auth).then((res) => {
      localStorage.clear();
      navigate("/services");
      window.location.reload();
    });
  };
  return (
    <div className="header">
      <nav className="navbar navbar-expand-lg navbar-dark bg-sky">
        <div className="container">
          <Link className="navbar-brand" to="#">
            <img src={Logo} alt="" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mr-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="#">
                  Home
                </Link>
              </li>
         
              <li className="nav-item">
                <Link className="nav-link text-light mx-2" to="#">
                  Services
                </Link>
              </li>            
              <li className="nav-item">
                {!user ? (
                  <Link className="nav-link text-light mx-2" to="/login">
                    Login
                  </Link>
                ) : (
                  <Link
                    className="nav-link text-light mx-2"
                    onClick={() => handleLogout()}
                    to="#"
                  >
                    Logout
                  </Link>
                )}
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};
export default Header;
